import React from 'react';

import handleChange, { useFormState } from './utils/handleChange';

import SubscriberInfo from './formsParts/SubscriberInfo';

//Individual Form Parts I-II//
import IndRegD from './formsParts/indRegMatters';
import MiscellaneousMatters from './formsParts/indMiscMatters';

//Entity Form Parts I-II//
import EntityRegulationMatters from './formsParts/entityRegMatters';
import EntityMiscMattersFund from './formsParts/entityMiscMattersFund';

//Other Functions//
import { generatePDF } from './generatePDF';
import generateExcel from './utils/excel';
import { handleSubmit } from './submit';
import { SignaturePad } from './signature';

function RealEstateFund_LP() {
    const [formData, setFormData] = useFormState();

    const today = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    
    const investorType = formData.investorType;
    const isIndividual = formData.investorType === 'individual';
    const isEntity = formData.investorType === 'entity';

    return (
        <div>
            <h1 className="center-text">TIL Subscription Agreement</h1>
            <h2 className="center-text">Real Estate Fund LP</h2>

            <p>
            By submitting this form, you (the Subscriber) hereby represent and warrant that all the information contained in this form is accurate in all respects. If you received an error message suggesting that you are not a fit for this investment vehicle, please contact the sponsor. You agree to indemnify the sponsor and the Fund for any and all claims, damages, or liabilities related to any inaccurate information you supply using this form.
            </p>

            <h4>To get started, please select your investor type:</h4>
            <select name="investorType" onChange={(event) => handleChange(event, setFormData)} value={formData.investorType || ''}>
                <option value="">Select Investor Type</option>
                <option value="individual">Individual</option>
                <option value="entity">Entity</option>
            </select>

            <form onSubmit={(event) => handleSubmit(event, formData, setFormData, investorType)}>
                {isIndividual && (
                    <div>
                        <h1 className="center-text">Investor Qualification Statement for Individuals</h1>
                        <h3 className="center-text">{today}</h3>

                      <SubscriberInfo formData={formData} handleChange={(e) => handleChange(e, setFormData)} />

                    <h2>Part I. Regulation D Matters.</h2>  
                      <IndRegD formData={formData} handleChange={(e) => handleChange(e, setFormData)} />

                        <h2>Part II. Miscellaneous Matters.</h2>
                        <MiscellaneousMatters formData={formData} handleChange={(e) => handleChange(e, setFormData)} />
                    
                    <br></br>
                    <br></br>

                    <p>
                        The Subscriber hereby represents and warrants that all of the answers, statements and information set forth in this Investor Qualification Statement are true and correct on the date hereof and will be true and correct as of each date, if any, that the subscription set forth in the Subscription Agreement to which this Investor Qualification Statement relates is accepted, in whole or in part, by the General Partner.  The Subscriber hereby agrees to provide such additional information related to the foregoing as is requested by the General Partner and to notify the General Partner promptly of any change that may cause any answer, statement or information set forth in this Investor Qualification Statement to become untrue in any material respect.
                    </p>

                    <SignaturePad formData={formData} setFormData={setFormData} />
                        <div>
                            <button type="submit" className='button-space'>Submit</button>
                            <button type="button" className='button-space' onClick={() => generatePDF(formData)}>Download as PDF</button>
                            <button type="button" onClick={() => generateExcel(formData, "InvestorData.xlsx")}>Download as Excel</button>
                        </div>
                </div>
                )}
            </form>

            <form onSubmit={(event) => handleSubmit(event, formData, setFormData, investorType)}>
                {isEntity && (
                    <div>
                        <h1 className="center-text">Investor Qualification Statement for Entities</h1>
                        <h3 className="center-text">{today}</h3>


                        <SubscriberInfo formData={formData}  handleChange={(e) => handleChange(e, setFormData)} />

                        <h2>Part I. Regulation D Matters.</h2>
                        <EntityRegulationMatters formData={formData} handleChange={(e) => handleChange(e, setFormData)} />

                        <h2> Part II. Miscellaneous Matters.</h2>
                        <EntityMiscMattersFund formData={formData} handleChange={(e) => handleChange(e, setFormData)} />


                    <br></br>
                    <br></br>

                    <p>
                        The Subscriber hereby represents and warrants that all of the answers, statements and information set forth in this Investor Qualification Statement are true and correct on the date hereof and will be true and correct as of each date, if any, that the subscription set forth in the Subscription Agreement to which this Investor Qualification Statement relates is accepted, in whole or in part, by the General Partner.  The Subscriber hereby agrees to provide such additional information related to the foregoing as is requested by the General Partner and to notify the General Partner promptly of any change that may cause any answer, statement or information set forth in this Investor Qualification Statement to become untrue in any material respect.
                    </p>

                    <SignaturePad formData={formData} setFormData={setFormData} />
                        <div>
                            <button type="submit" className='button-space'>Submit</button>
                            <button type="button" className='button-space' onClick={() => generatePDF(formData)}>Download as PDF</button>
                            <button type="button" onClick={() => generateExcel(formData, "InvestorData.xlsx")}>Download as Excel</button>
                        </div>
                </div>
                )}
            </form>

        </div>
    );
}

export default RealEstateFund_LP;
